module.exports = __webpack_public_path__ + "static/melbourne-brewery-98502b0b56379338e2125d151ea1f941.mp4";